import { SVGProps } from "react";

export function SearchWithBG(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="120"
      height="120"
      viewBox="0 0 120 120"
      fill="none"
      {...props}
    >
      <circle cx="60" cy="60" r="60" fill="#E6EBF3" />
      <g clip-path="url(#clip0_11848_17931)">
        <path
          d="M56.3983 36.0001C60.2286 35.9998 63.9816 37.0779 67.2278 39.111C70.474 41.1441 73.0822 44.0501 74.754 47.4963C76.4258 50.9425 77.0936 54.7898 76.6809 58.5978C76.2683 62.4059 74.7919 66.0208 72.4207 69.0289L81.1855 77.7937C81.6226 78.2463 81.8646 78.8526 81.8591 79.4819C81.8536 80.1111 81.6012 80.7131 81.1562 81.1581C80.7113 81.603 80.1093 81.8554 79.48 81.8609C78.8508 81.8664 78.2445 81.6245 77.7919 81.1873L69.0271 72.4225C66.4721 74.436 63.4727 75.8093 60.2791 76.4279C57.0855 77.0464 53.7902 76.8923 50.6683 75.9783C47.5464 75.0644 44.6883 73.417 42.3324 71.1738C39.9766 68.9306 38.1914 66.1566 37.1257 63.0831C36.0601 60.0096 35.7448 56.7259 36.2064 53.5058C36.6679 50.2857 37.8928 47.2227 39.7788 44.5723C41.6649 41.9219 44.1574 39.7609 47.0485 38.2698C49.9395 36.7786 53.1453 36.0004 56.3983 36.0001ZM56.3983 40.8001C52.2609 40.8001 48.293 42.4437 45.3674 45.3692C42.4418 48.2948 40.7983 52.2627 40.7983 56.4001C40.7983 60.5375 42.4418 64.5054 45.3674 67.431C48.293 70.3565 52.2609 72.0001 56.3983 72.0001C60.5356 72.0001 64.5036 70.3565 67.4291 67.431C70.3547 64.5054 71.9983 60.5375 71.9983 56.4001C71.9983 52.2627 70.3547 48.2948 67.4291 45.3692C64.5036 42.4437 60.5356 40.8001 56.3983 40.8001ZM56.3983 43.2001C59.8991 43.2001 63.2566 44.5908 65.7321 47.0663C68.2076 49.5418 69.5983 52.8992 69.5983 56.4001C69.5983 59.9009 68.2076 63.2584 65.7321 65.7339C63.2566 68.2094 59.8991 69.6001 56.3983 69.6001C52.8974 69.6001 49.5399 68.2094 47.0645 65.7339C44.589 63.2584 43.1983 59.9009 43.1983 56.4001C43.1983 52.8992 44.589 49.5418 47.0645 47.0663C49.5399 44.5908 52.8974 43.2001 56.3983 43.2001Z"
          fill="#063982"
        />
      </g>
      <defs>
        <clipPath id="clip0_11848_17931">
          <rect width="57.6" height="57.6" fill="white" transform="translate(31.1953 31.2)" />
        </clipPath>
      </defs>
    </svg>
  );
}

